import actions from './store/actions';

//REPLACE INTO eurostars2018_cms.MOD_giftVoucher_conf VALUES ('show_addresse', '0');
// REPLACE INTO eurostars2018_cms.MOD_giftVoucher_conf VALUES ('show_news_check', '1');

const {
    langInfo: langActions,
    webType: webTypeActions,
    currencies: currenciesActions,
    mainCurrencies: mainCurrenciesActions,
    currentCurrency: currentCurrencyActions,
    currentManagementGroup: currentManagementGroupActions,
    currentHotel: currentHotelActions,
    showAddresse: showAddresseActions,
    showNewsCheck: showNewsCheckActions,
    reservationRequest: reservationRequestActions,
    rawRequest: rawRequestActions,
    formCurrency: formCurrencyActions,
    trackingId: trackingIdActions,
} = actions.customer;
const {
    tpv: tpvActions,
    giftVoucher: giftVoucherActions,
} = actions;

const initializeStore = (baseRoute, arrayHash, queryObj, dispatch) => {
    window.availabilityReactTestingMode = !!queryObj.testing_mode;

    //set window data
    dispatch(langActions.get(window.lang_info));

    dispatch(webTypeActions.get(window.web_type));
    dispatch(tpvActions.get(window.tpv));
    dispatch(actions.countries.get(window.countries, window.lang_info));

    if(window.management_group) {
        dispatch(currentManagementGroupActions.get(window.management_group));
        dispatch(formCurrencyActions.get(window.management_group_currency));
    } else {
        dispatch(currentHotelActions.get(window.hotel));
        dispatch(formCurrencyActions.get(window.hotel_currency));
    }

    dispatch(showAddresseActions.get(window.show_addresse));
    dispatch(showNewsCheckActions.get(window.show_news_check));
    dispatch(trackingIdActions.get());

    dispatch(currenciesActions.get(window.currencies));
    dispatch(mainCurrenciesActions.get(window.main_currencies));
    dispatch(currentCurrencyActions.set(window.engine_sygy_data.currency));

    dispatch(giftVoucherActions.get(window.gift_voucher_list));
    dispatch(rawRequestActions.get());
    dispatch(reservationRequestActions.create());
};

export default initializeStore;
